<template>
    <div class="gateway-tab">
        <div class="flex items-center">
            <div @click="tabSelected = tab" v-for="(tab) in tabs"
                :class="{ 'bg-gray-200 font-semibold text-success !border-b-gray-200 !border-b-0': tab == tabSelected }"
                class="cursor-pointer border border-gray-200 rounded-t-sm h-10 px-4 flex items-center justify-center">
                {{ tab }}
            </div>
        </div>
        <div class="px-3 py-4 border border-gray-200 border-t-0 bg-gray-200 rounded-b-sm rounded-tr-sm">
            <div v-for="(tab) in tabs">
                <slot v-if="tab == tabSelected" :name="tab"></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default defineComponent({
    props: {
        tabs: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            tabSelected: this.tabs[0],
        };
    },
    watch: {
        tabSelected() {

        }
    }
})
</script>
  